import { lngRole, lngStatus, lngSlot } from '../sys_strings';
import { tokens } from '../tokens';
import { appStr } from '../app_strings';

const itemRole = {
  [lngRole.teacher]: 'Giáo viên',
  [lngRole.officer]: 'Giáo vụ',
  [lngRole.accountant]: 'Kế toán',
  [lngRole.leader]: 'Quản lý',
  [lngRole.administrator]: 'Quản trị viên',
  [lngRole.seller]: 'Kinh doanh',
  [lngRole.censor]: 'Kiểm duyệt',
  [lngRole.highest]: 'Prototype',
};

const itemStatus = {
  [lngStatus.new]: 'Mới thêm',
  [lngStatus.pending]: 'Chờ sắp lịch',
  [lngStatus.confirmed]: 'Đã sắp lịch',
  [lngStatus.processing]: 'Đã phân công',
  [lngStatus.shipping]: 'Đang dạy',
  [lngStatus.delivered]: 'Delivered',
  [lngStatus.completed]: 'Completed',
  [lngStatus.cancelled]: 'Cancelled',
  [lngStatus.onHold]: 'On_Hold',
  [lngStatus.reserved]: 'Bảo lưu',
  [lngStatus.returned]: 'Returned',
  [lngStatus.refunded]: 'Refunded',
  [lngStatus.failed]: 'Failed',
  [lngStatus.awaitingPayment]: 'Awaiting Payment',
  [lngStatus.partiallyShipped]: 'Partially Shipped',
  [lngStatus.backordered]: 'Backordered',
  [lngStatus.awaitingFulfillment]: 'Awaiting Fulfillment',
};

const itemTokens = {
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.nav.academy]: 'Học viện',
  [tokens.nav.account]: 'Tài Khoản',
  [tokens.nav.auth]: 'Auth',
  [tokens.nav.calendar]: 'Lịch',
  [tokens.nav.chat]: 'Trò chuyện',
  [tokens.nav.checkout]: 'Checkout',
  [tokens.nav.concepts]: 'Khái niệm',
  [tokens.nav.contact]: 'Liên Hệ',
  [tokens.nav.course]: 'Khóa học',
  [tokens.nav.create]: 'Tạo mới',
  [tokens.nav.customers]: 'Khách hàng',
  [tokens.nav.teachers]: 'Giáo viên',
  [tokens.nav.students]: 'Học viên',
  [tokens.nav.studentNew]: 'Học viên mới',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.details]: 'Chi tiết',
  [tokens.nav.edit]: 'Sửa',
  [tokens.nav.error]: 'Lỗi',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'Tập tin',
  [tokens.nav.forgotPassword]: 'Quên mật khẩu',
  [tokens.nav.list]: 'List',
  [tokens.nav.login]: 'Đăng Nhập',
  [tokens.nav.logistics]: 'Vận tải',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Quản lý',
  [tokens.nav.orderList]: 'Lịch dạy',
  [tokens.nav.overview]: 'Tổng Quan',
  [tokens.nav.pages]: 'Trang',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Giá',
  [tokens.nav.productList]: 'Sản phẩm',
  [tokens.nav.profile]: 'Hồ sơ',
  [tokens.nav.register]: 'Đăng Ký',
  [tokens.nav.resetPassword]: 'Đặt lại mật khẩu',
  [tokens.nav.socialMedia]: 'Truyền thông',
  [tokens.nav.verifyCode]: 'Xác minh mã',
  [tokens.nav.payroll]: 'Bảng lương',
  [tokens.nav.payslip]: 'Phiếu lương',
  [tokens.nav.fuel]: 'Nhiên liệu',
  [tokens.nav.repair]: 'Bảo dưỡng',
  [tokens.nav.tms]: 'Chấm công',
  [tokens.nav.car]: 'Xe ôtô',
  [tokens.nav.partner]: 'Đối tác',
  [tokens.nav.staff]: 'Nhân viên',
  [tokens.nav.workSchedule]: 'Lịch công tác',
  [tokens.nav.repairRequest]: 'Đề xuất bảo dưỡng',
  [tokens.nav.carManagement]: 'Quản lý xe',
  [tokens.nav.groups]: 'Quản lý đơn vị',
  [tokens.nav.repairSchedule]: 'Lịch bảo dưỡng',
  [tokens.nav.demo]: 'Basic Demo',
  [tokens.nav.tickets]: 'Phiếu báo',
  [tokens.nav.tracking]: 'Quy trình đào tạo',
};

const itemSlot = {
  [lngSlot.morning]: 'Ca sáng',
  [lngSlot.evening]: 'Ca chiều',
  [lngSlot.night]: 'Ca tối',
};

const itemAppStr = {
  [appStr.txt_001]: 'Tìm kiếm',
  [appStr.txt_002]: 'Họ tên',
  [appStr.txt_003]: 'Số giờ',
  [appStr.txt_004]: 'Số km',
  [appStr.txt_005]: 'Mã giáo viên',
  [appStr.txt_006]: 'Mã học viên',
  [appStr.txt_007]: 'Ngày tạo',
  [appStr.txt_008]: 'Tên thư mục',
  [appStr.txt_009]: 'Tổng tập tin',
  [appStr.txt_010]: 'Cập nhật',
  [appStr.txt_011]: 'Hoàn thành',
  [appStr.txt_012]: 'Trang chủ',
  [appStr.txt_013]: 'Km Ca',
  [appStr.txt_014]: 'Giờ Ca',
  [appStr.txt_015]: 'Giờ AT',
  [appStr.txt_016]: 'Giờ Đêm',
  [appStr.txt_017]: 'Số KM đã học',
  [appStr.txt_018]: 'Thời gian đã học',
  [appStr.txt_019]: 'Mã khóa học',
  [appStr.txt_020]: 'Số điện thoại',
  [appStr.txt_021]: 'Công tác tại',
  [appStr.txt_022]: 'Sinh nhật',
  [appStr.txt_023]: 'Khóa học',
  [appStr.txt_024]: 'Mã đơn',
  [appStr.txt_025]: 'Trạng thái',
  [appStr.txt_026]: 'Ngày ca',
  [appStr.txt_027]: 'Giờ ca',
  [appStr.txt_028]: 'Lịch dạy',
  [appStr.txt_029]: 'Nhóm',
  [appStr.txt_030]: 'Ngày tháng',
  [appStr.txt_031]: 'Thêm',
  [appStr.txt_032]: 'Tên học viên',
  [appStr.txt_033]: 'Tên giáo viên',
  [appStr.txt_034]: 'Biển số',
  [appStr.txt_035]: 'Ngày đổ (d/m/y)',
  [appStr.txt_036]: 'Số lượng',
  [appStr.txt_037]: 'Nơi công tác',
  [appStr.txt_038]: 'Giờ vào',
  [appStr.txt_039]: 'Giờ ra',
  [appStr.txt_040]: 'Biển số xe',
  [appStr.txt_041]: 'Ngày bảo dưỡng',
  [appStr.txt_042]: 'Mục bảo dưỡng',
  [appStr.txt_043]: 'Giá (đ)',
  [appStr.txt_044]: 'Tài khoản',
  [appStr.txt_045]: 'Thông tin',
  [appStr.txt_046]: 'Mật khẩu',
  [appStr.txt_047]: 'Chọn',
  [appStr.txt_048]: 'Thay đổi',
  [appStr.txt_049]: 'Người nhận',
  [appStr.txt_050]: 'Sửa',
  [appStr.txt_051]: 'Lưu',
  [appStr.txt_052]: 'Tên đăng nhập đang trống',
  [appStr.txt_053]: 'Mật khẩu đang trống',
  [appStr.txt_054]: 'Tại Km',
  [appStr.txt_055]: 'Nhận xe',
  [appStr.txt_056]: 'Trả xe',
  [appStr.txt_057]: 'Xe số',
  [appStr.txt_058]: 'Hiệu xe',
  [appStr.txt_059]: 'Mã số',
  [appStr.txt_060]: 'Tên đối tác',
  [appStr.txt_061]: 'Tên đơn vị',
  [appStr.txt_062]: 'Bảng tóm tắt',
  [appStr.txt_063]: 'Số thẻ',
  [appStr.txt_064]: 'Hóa đơn',
  [appStr.txt_065]: 'Ngày xe ra (d/m/y)',
  [appStr.txt_066]: 'Thống kê',
  [appStr.txt_067]: 'Xe được giao',
  [appStr.txt_068]: 'Theo (ngày/tháng/năm)',
  [appStr.txt_069]: 'Số thẻ',
  [appStr.txt_070]: 'Ngày bảo dưỡng (d/m/y)',
  [appStr.txt_071]: 'Mã học viên',
  [appStr.txt_072]: 'Mã trên máy dat',
  [appStr.txt_073]: 'Hạng',
  [appStr.txt_074]: 'Tiến độ',
  [appStr.txt_075]: 'Loại phiếu',
};

const itemAssistant = {
  ['search_tooltip']:
    'Sử dụng dấu "phẩy, khoảng trắng" trên cùng bộ lọc, sẽ tăng phạm vi tìm kiếm' +
    '<br />Vd: Tìm sđt "3456, 4321"' +
    '<br />Kết quả là (0932003456, 0908004321)' +
    '<p />Theo thời gian: dd/mm/yyyy hoặc dd-mm-yyyy' +
    '<br />1. "24/12/2023" Trong ngày 24 tháng 12 năm 2023' +
    '<br />2. "24/12/2023 14/02/2024" Từ ngày 24/12/2023 Đến ngày 14/02/2024' +
    '<p />** Sử dụng bộ lọc để "Giới Hạn" phạm vi tìm kiếm **',
};

const itemSearch = {
  ['bill']: 'Hóa đơn',
  ['card']: 'Số thẻ',
  ['code']: 'Mã số',
  ['date']: 'Thời gian',
  ['group']: 'Đơn vị',
  ['name']: 'Tên gọi',
  ['phone']: 'Điện thoại',
  ['plate']: 'Biển số',
  ['place']: 'Địa điểm',
  ['partner']: 'Đối tác',
};

export const vn = {
  ...itemRole,
  ...itemStatus,
  ...itemTokens,
  ...itemSlot,
  ...itemAppStr,
  ...itemAssistant,
  ...itemSearch,

  ['OOPS']: 'Oops, Something went wrong',
  ['EDIT_ERR']: 'Lỗi xảy ra trong quá trình cập nhật',
  ['EDIT_OK']: 'Thay đổi thành công',
  ['ECS_x']: 'Lỗi từ server',
  ['coming_soon']: 'Đang xây dựng',
};
